export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-960-31d0a0ffd1bb6039002f07d9f2024efb.webp";